import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { CompanyAuthenticationTabDataProviderFactory } from '../factory/CompanyAuthenticationTabDataProviderFactory';
import { CompanyAuthenticationTabBaseDataProvider } from '../dataProvider/CompanyAuthenticationTabBaseDataProvider';
import { MyCompanyAuthenticationData } from '../../../types/company-data';

export class CompanyAuthenticationTabRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CompanyAuthenticationTabDataProviderFactory;
  public dataProvider: CompanyAuthenticationTabBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CompanyAuthenticationTabDataProviderFactory(),
    });
  }

  async getMyCompanyAuthenticationData(companyId: string): Promise<MyCompanyAuthenticationData> {
    return this.dataProvider.getMyCompanyAuthenticationData(companyId);
  }
}
